export const PREFIX_CLS = 'wmstool-fullcalendar';



// WEBPACK FOOTER //
// ./components/calendar/Constants.tsx